import React, { useState } from "react";
import "./FAQ.css";
import { Modal } from "react-bootstrap";
import { MdClose } from "react-icons/md";

export default function FAQ(props) {
  const [showAnswerModal, setShowAnswerModal] = useState(false);

  const showAnswerHandler = () => {
    setShowAnswerModal(true);
  };

  const handleClose = () => {
    setShowAnswerModal(false);
  };

  const renderTextWithLineBreaks = (text) => {
    return text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  return (
    <>
      <div
        className="faq horizontalBorder centeredFlex"
        onClick={showAnswerHandler}
      >
        <img
          src="/images/arrowSquareRight.svg"
          className="arrowSquareRight"
          alt="arrow icon"
        />
        <span>{props.question}</span>
        <img
          src="/images/question.png"
          className="questionImg"
          alt="question icon"
        />
      </div>
      <Modal
        show={showAnswerModal}
        dialogClassName="questionModal"
        contentClassName="customModalContent"
        onHide={handleClose}
      >
        <div>
          <MdClose className="closeAnswerIcon" onClick={handleClose} />
        </div>
        <div className="answerModal centeredFlex">
          {props.answer.map((answerPart, index) => (
            <div key={index} className="answerPart">
              <div className="pinkSquare"></div>
              <p>{renderTextWithLineBreaks(answerPart)}</p>
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
}
